<template>
  <div>
    <div v-for="(slide , i ) in stepsRender" :key="i" class="step"
         :class="'slide'+slide.id+''" :style="i != 0 && 'opacity: 0;display: none;'">
      <div class="titleStep mb-5">
        {{ slide.title }}
      </div>
      <v-row justify="center">
        <v-col v-for="(item  , n ) in slide.items" cols="6" lg="4" :key="n">
          <SelectableWizardMatchMaking :data="item" :keyStep="slide.key" :step-data="stepData"
                                       :primary-key="'profile'"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
/*eslint-disab*/
import SelectableWizardMatchMaking from "@/components/MatchMaking/selectableWizardMatchMaking";
import gsap from "gsap";

export default {
  components: {SelectableWizardMatchMaking},
  props: {
    next: Boolean,
    prev: Boolean,
    stepData: Object,
  },
  data() {
    return {
      stepsRender: [
        {
          key: "category",
          id: 1,
          title: this.$t('onBoarding.stepTwo.title'),
          subTitle: this.$t('onBoarding.stepTwo.subtitle'),
          items: [
            {
              title: this.$t('onBoarding.stepTwo.cycles[0]'),
              image: require('@/assets/new-design/cycles/individual.svg'),
              val: 'فردی',
              key: 'individual'
            },
            {
              title: this.$t('onBoarding.stepTwo.cycles[1]'),
              image: require('@/assets/new-design/cycles/relation.svg'),
              val: 'رابطه و زوج درمانی',
              key: 'married'
            },
            {
              title: this.$t('onBoarding.stepTwo.cycles[2]'),
              image: require('@/assets/new-design/cycles/teen.svg'),
              val: 'کودک و نوجوان',
              key: 'child'
            },
          ]
        },
        {
          id: 2,
          key: 'gender',
          title: this.$t('onBoarding.stepThree.title'),
          subTitle: null,
          items: [
            {
              title: this.$t('onBoarding.stepThree.gender[0]'),
              image: require('@/assets/new-design/genders/male.svg'),
              val: 'مرد',
              key: 'men',
            },
            {
              title: this.$t('onBoarding.stepThree.gender[1]'),
              image: require('@/assets/new-design/genders/female.svg'),
              val: 'زن',
              key: 'women',
            },
            {
              title: this.$t('onBoarding.stepThree.gender[2]'),
              image: require('@/assets/new-design/genders/other.svg'),
              val: 'موارد دیگر',
              key: 'other'
            },
          ]
        },
        {
          id: 3,
          key: 'age',
          title: this.$t('onBoarding.stepFour.title'),
          subTitle: null,
          items: [
            {
              title: this.$t('onBoarding.stepFour.agePeriods[0]'),
              val: 'کمتر از 18',
              key: '18'
            },
            {
              title: '19 - 25',
              val: '19 - 25',
              key: '1925'
            },
            {
              title: '26 - 30',
              val: '26 - 30',
              key: '2630'
            },
            {
              title: '31 - 35',
              val: '31 - 35',
              key: '3135'
            },
            {
              title: '36 - 45',
              val: '36 - 45',
              key: '3645'
            },
            {
              title: this.$t('onBoarding.stepFour.agePeriods[1]'),
              val: 'بیشتر از 45',
              key: '45'
            },
          ]
        },
        {
          id: 4,
          key: 'relationship',
          title: this.$t('onBoarding.stepFive.title'),
          subTitle: null,
          items: [
            {
              title: this.$t('onBoarding.stepFive.relationships[0]'),
              image: require('@/assets/new-design/relationship/single.svg'),
              val: 'مجرد',
              key: 'single'
            },
            {
              title: this.$t('onBoarding.stepFive.relationships[1]'),
              image: require('@/assets/new-design/relationship/married.svg'),
              val: 'متاهل',
              key: 'couple'
            },
            {
              title: this.$t('onBoarding.stepFive.relationships[2]'),
              image: require('@/assets/new-design/relationship/relationship.svg'),
              val: 'شریک عاطفی',
              key: 'rel'
            },
            {
              title: this.$t('onBoarding.stepFive.relationships[3]'),
              image: require('@/assets/new-design/relationship/other.svg'),
              val: 'موارد دیگر',
              key: 'otherState'
            },
          ]
        },
      ],
      activeStep: null,
      lock: false,
      lockPrev: false,
    }
  },
  created() {
    this.activeStep = this.stepsRender[0]
  },
  methods: {
    nextStep() {
      if (!this.lock) {
        this.lock = true
        gsap.to(`.slide${this.activeStep.id}`, {x: -10, opacity: 0, display: 'none'}).then(() => {
          gsap.fromTo(`.slide${this.activeStep.id + 1}`, {x: 20, opacity: 0, display: 'none'}, {
            x: 0,
            opacity: 1,
            display: 'block'
          })
          this.activeStep = this.stepsRender.find(item => item.id == (this.activeStep.id + 1))
          this.$emitEvent('changeActiveStepInner', this.activeStep.key)
          this.lock = false
        })
      }
    },
    prevStep() {
      if (!this.prevLock) {
        this.prevLock = true
        gsap.to(`.slide${this.activeStep.id}`, {x: 10, opacity: 0, display: 'none'}).then(() => {
          gsap.fromTo(`.slide${this.activeStep.id - 1}`, {x: -20, opacity: 0, display: 'none'}, {
            x: 0,
            opacity: 1,
            display: 'block'
          })
          this.activeStep = this.stepsRender.find(item => item.id == (this.activeStep.id - 1))
          this.$emitEvent('changeActiveStepInner', this.activeStep.key)
          this.prevLock = false
        })
      }
    }
  },
  watch: {
    next(val) {
      if (val) {
        this.nextStep()
      }
    },
    prev(val) {
      if (val) {
        this.prevStep()
      }
    }
  }
}
</script>

<style scoped>
.titleStep {
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.41;
  letter-spacing: normal;
  text-align: center;
  color: #000;
}

.step {
  margin-top: 50px;
}

</style>
